<h2 mat-dialog-title>{{ "intimation.delete" | translate }}</h2>
<mat-dialog-actions class="mat-card-action">
  <button mat-button mat-raised-button mat-dialog-close>
    {{ "intimation.Cancel" | translate }}
  </button>
  <button mat-button mat-raised-button color="primary" (click)="DeleteData()">
    {{ "intimation.ok" | translate }}
  </button>
</mat-dialog-actions>
